/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationRejectedTombstoneContainer_local = {
    readonly accessToken: string | null;
    readonly " $refType": "ModerationRejectedTombstoneContainer_local";
};
export type ModerationRejectedTombstoneContainer_local$data = ModerationRejectedTombstoneContainer_local;
export type ModerationRejectedTombstoneContainer_local$key = {
    readonly " $data"?: ModerationRejectedTombstoneContainer_local$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationRejectedTombstoneContainer_local">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationRejectedTombstoneContainer_local",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '436e5d1c2dbbe1226572cd0eb17db6f3';
export default node;
